module.exports = {
      id: "recording-usage",
      viewBox: "0 0 11 17",
      url: "img/" + "sprite.svg#recording-usage",
      toString: function () {
        return this.url;
      }
    }